<template>
  <v-app>
    <!--Mobile-->
    <template v-if="$vuetify.breakpoint.mobile">
      <div class="principal-logo" v-if="$route.path != '/cgu' && $route.path != '/politique-confidentialite'">
        <router-link to="/">
            <v-img height="50" contain src="/img/logo.png" />
          </router-link>
      </div>
  
    <v-main>
      <MaintenanceModal />

        <transition name="fade" mode="out-in">
            <router-view />
          </transition>
    </v-main>
      <!-- navbar bottom navigation -->
      <v-bottom-navigation v-if="!isLoginPage && $route.path != '/cgu' && $route.path != '/politique-confidentialite'" elevation="0" v-model="activeRoute" color="secondary" height="50"
        fixed>
        <v-btn :disabled="item.disabled || $route.path == item.to" v-for="item in items" :key="item.title" class="py-3"
          :to="item.to" exact icon>
          <span v-html="item.svg">
          </span>
          <NotificationStickerComponent
        v-if="false"
          :location=item.locationNotification
          :type=item.typeNotification
          style="top: 3px;right: 3px"
        />
      </v-btn>
      </v-bottom-navigation>
    </template>
    <!--Desktop-->
    <template v-else>
      <v-app-bar v-if="$route.path != '/cgu' && $route.path != '/politique-confidentialite'" app color="light" flat>
        <v-img height="50" width="50" contain @click="$router.push('/')"
        :style="{
          cursor: 'pointer',
        }"
        src="/img/logo.png" />
        <v-spacer v-if="!isLoginPage"/>
        <v-text-field v-if="!isLoginPage" solo hide-details rounded dense outlined light class="white"  v-model="searchModel" filled placeholder="Rechercher" @focus="$router.push('/wall/search')"
         />
        <v-spacer v-if="!isLoginPage"/>
        <v-badge v-if="false" color="primary" overlap> //TODO
          <template v-slot:badge>
            <span class="black--text">1</span>
          </template>
          <v-icon small :style="{
            transform: 'rotate(-45deg)',
          }">mdi-send</v-icon>
        </v-badge>
        <v-menu offset-y v-if="!isLoginPage">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <UserAvatar 
                class="mr-2"
                :size="30"
                :avatar="user.avatar"
                :first-name="user.first_name"
                :last-name="user.last_name"
              />
              {{ user.first_name }} {{ user.last_name }}
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/wall/profil" style="color: black !important;">
              <v-list-item-title>Profil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout()">
              <v-list-item-title>Se déconnecter</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-main :style="{ backgroundColor: backgroundColor, height:'calc(100% - 64px)' }">
        <MaintenanceModal />
        <router-view />
      </v-main>
    </template>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import NotificationStickerComponent from "@/components/NotificationSticker.vue";
import  OneSignal   from 'onesignal-cordova-plugin';
import MaintenanceModal from "@/components/MaintenanceModal.vue";
import packageInfo from '../package.json';


export default {
  name: 'App',
  components: {NotificationStickerComponent, MaintenanceModal},
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    isLoginPage() {
      return ['/login', '/register', '/forgot-password'].includes(this.$route.path);
    },
    items(){
      return [
      {
        title: 'Home',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" width="19.228" height="19.683" viewBox="0 0 19.228 19.683">
          <path id="Tracé_4" data-name="Tracé 4" d="M159.834,1923.407H142.606v-11.358l8.344-6.1,8.884,6.1Z" transform="translate(-141.606 -1904.723)" fill="none" stroke="#2b2b2b" stroke-width="2"/>
        </svg>`,
        to: '/',
        disabled: false,
        locationNotification:'home',
        typeNotification:'number',
      },
      {
        title: 'Search',
        svg: `<svg id="Groupe_2" data-name="Groupe 2" xmlns="http://www.w3.org/2000/svg" width="23.51" height="26.156" viewBox="0 0 23.51 26.156">
          <g id="Ellipse_1" data-name="Ellipse 1" fill="none" stroke="#2b2b2b" stroke-width="2">
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none"/>
            <circle cx="10.5" cy="10.5" r="9.5" fill="none"/>
          </g>
          <path id="Tracé_3" data-name="Tracé 3" d="M41.874,91.5l5.78,6.757" transform="translate(-25.554 -73.511)" fill="none" stroke="#2b2b2b" stroke-linecap="round" stroke-width="2"/>
        </svg>
        `,
        to: '/wall/search',
        disabled: false,
        locationNotification:'search',
        typeNotification:'warning',
      },
      {
        title: 'Message',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" width="29.2" height="27.134" viewBox="0 0 29.2 27.134">
          <path id="Tracé_3892" data-name="Tracé 3892" d="M12.953,16.065,25.248,4.648,16.469,23.385ZM4.037,11.816,23.849,3.81,11.775,15.022ZM0,11.8l11.388,4.718,5.1,10.618L29.2,0Z" fill="#2b2b2b"/>
        </svg>
        `,
        to: '/wall',
        disabled: false,
        locationNotification:'wall',
        typeNotification:'number',
      },
      {
        title: 'Annuaire',
        svg: `<svg id="Groupe_83" data-name="Groupe 83" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17.191" height="31.733" viewBox="0 0 17.191 31.733">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_598" data-name="Rectangle 598" width="17.191" height="31.733" fill="#2b2b2b"/>
            </clipPath>
          </defs>
          <g id="Groupe_83-2" data-name="Groupe 83" clip-path="url(#clip-path)">
            <path id="Tracé_3893" data-name="Tracé 3893" d="M9.139,0A6.3,6.3,0,0,0,3.007,6.448a6.294,6.294,0,0,0,6.132,6.445A6.294,6.294,0,0,0,15.27,6.448,6.294,6.294,0,0,0,9.139,0m0,11.13A4.6,4.6,0,0,1,4.646,6.448,4.6,4.6,0,0,1,9.139,1.763a4.6,4.6,0,0,1,4.492,4.685A4.6,4.6,0,0,1,9.139,11.13" transform="translate(-0.543)" fill="#2b2b2b"/>
            <path id="Tracé_3894" data-name="Tracé 3894" d="M16.307,19.965a3.246,3.246,0,0,0-3.162-3.324H3.979A3.247,3.247,0,0,0,.817,19.965L0,30.481c0,1.837,2.127,3.224,3.874,3.224h9.588c1.746,0,3.729-1.075,3.729-2.91ZM13.462,31.942H3.874c-1.031,0-2.176-.828-2.232-1.417l.81-10.415c0-.048,0-.1,0-.146A1.544,1.544,0,0,1,3.979,18.4h9.167a1.545,1.545,0,0,1,1.523,1.561c0,.052,0,.1.007.153l.875,10.726c-.057.551-1.081,1.1-2.088,1.1" transform="translate(0 -1.972)" fill="#393737"/>
          </g>
        </svg>
        `,
        to: '/wall/profil',
        disabled: false,
        locationNotification:'profil',
        typeNotification:'warning',
      },
      {
        title: 'user',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" width="20.181" height="33.189" viewBox="0 0 20.181 33.189">
          <g id="Groupe_429" data-name="Groupe 429" transform="translate(-7795.068 3650.164)">
            <g id="Tracé_5258" data-name="Tracé 5258" transform="translate(7795.068 -3642.916)" fill="none">
              <path d="M2.388,0H6.152S7.16,3.9,10.359,3.812,14.173,0,14.173,0h3.621c1.319,0,2.388,1.4,2.388,3.126V22.816c0,1.726-1.069,3.125-2.388,3.125H2.388C1.069,25.942,0,24.542,0,22.816V3.126C0,1.4,1.069,0,2.388,0Z" stroke="none"/>
              <path d="M 2.388330459594727 1.499994277954102 C 2.034679412841797 1.499994277954102 1.5 2.1483154296875 1.5 3.125495910644531 L 1.5 22.81615447998047 C 1.5 23.7933349609375 2.034679412841797 24.4416446685791 2.388330459594727 24.4416446685791 L 17.79308891296387 24.4416446685791 C 18.1467399597168 24.4416446685791 18.68141937255859 23.7933349609375 18.68141937255859 22.81615447998047 L 18.68141937255859 3.125495910644531 C 18.68141937255859 2.1483154296875 18.1467399597168 1.499994277954102 17.79308891296387 1.499994277954102 L 15.29769325256348 1.499994277954102 C 15.16621017456055 1.848072052001953 14.99059295654297 2.23890495300293 14.75870990753174 2.633665084838867 C 13.77306938171387 4.311624526977539 12.22480010986328 5.262754440307617 10.39914989471436 5.311824798583984 C 10.35063934326172 5.313125610351562 10.30268001556396 5.313764572143555 10.25488948822021 5.313764572143555 C 8.455459594726562 5.313764572143555 6.910429954528809 4.423545837402344 5.786839485168457 2.739336013793945 C 5.496871948242188 2.304681777954102 5.273994445800781 1.873374938964844 5.107648849487305 1.499994277954102 L 2.388330459594727 1.499994277954102 M 2.388330459594727 -5.7220458984375e-06 L 6.152119636535645 -5.7220458984375e-06 C 6.152119636535645 -5.7220458984375e-06 7.159647941589355 3.898494720458984 10.35881996154785 3.81236457824707 C 13.55792999267578 3.726375579833984 14.17251968383789 -5.7220458984375e-06 14.17251968383789 -5.7220458984375e-06 L 17.79308891296387 -5.7220458984375e-06 C 19.11212921142578 -5.7220458984375e-06 20.18141937255859 1.399335861206055 20.18141937255859 3.125495910644531 L 20.18141937255859 22.81615447998047 C 20.18141937255859 24.54231452941895 19.11212921142578 25.9416446685791 17.79308891296387 25.9416446685791 L 2.388330459594727 25.9416446685791 C 1.069290161132812 25.9416446685791 0 24.54231452941895 0 22.81615447998047 L 0 3.125495910644531 C 0 1.399335861206055 1.069290161132812 -5.7220458984375e-06 2.388330459594727 -5.7220458984375e-06 Z" stroke="none" fill="#2b2b2b"/>
            </g>
            <g id="Rectangle_814" data-name="Rectangle 814" transform="translate(7802.815 -3650.164)" fill="none" stroke="#2b2b2b" stroke-width="1.5">
              <rect width="5" height="9" rx="2.5" stroke="none"/>
              <rect x="0.75" y="0.75" width="3.5" height="7.5" rx="1.75" fill="none"/>
            </g>
          </g>
        </svg>
        `,
        to:`/user/${this.user.id}`,
        disabled: false,
        locationNotification:'user',
        typeNotification:'number',
      }
    ]
    }
  },
  data: () => ({
    searchModel: '',
    activeRoute: null,
    backgroundColor: '',
  }),
  async mounted() {
    //this.getNotification();

    // Enregistrer la version du site si on est en mode desktop
    if (this.$vuetify.breakpoint.mobile) {
      OneSignal.initialize("9edac120-d954-4d70-9e9e-f67554d83c90");
      OneSignal.Notifications.requestPermission();
    }
  },
  async created() {
    // Attendre que l'authentification soit chargée avant de mettre à jour la version
    if(!this.$vuetify.breakpoint.mobile){
      this.waitForAuthAndUpdateVersion();
    }
  },
  methods: {
    async waitForAuthAndUpdateVersion() {
      // Attendre que l'authentification soit chargée
      while (!this.$store.state.isAuthLoaded) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      
      // Attendre que l'utilisateur soit disponible
      while (!this.user || !this.user.id) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      
      // Maintenant on peut mettre à jour la version
      await this.updateSiteVersion();

    },
    logout(){
      localStorage.clear();
      this.$router.push('/login');
    },
    getNotification(){
      this.$strapi.find('notifications', {
        filters: {
          user_id:this.user.id,
          read:false,
        }
      }).then(res => {
        console.log('setNotifications in store :',res.data)
        this.$store.dispatch('setNotifications', res.data)
      }).catch(error => {
        console.error('Erreur lors de la récupération des notifications:', error);
      });
    },
    async updateSiteVersion() {
      try {
        // Vérifier que l'utilisateur est connecté
        if (!this.user || !this.user.id) {
          console.log('Utilisateur non connecté, impossible de mettre à jour la version');
          return;
        }

        const currentVersion = packageInfo.version;
        const currentBuildDate = packageInfo.buildDate;
        const currentDateTime = new Date().toISOString();

        // Récupérer les métadonnées existantes
        const existingMetadata = this.user.metadata || {};

        // Vérifier si la version a changé
        const versionChanged = existingMetadata.siteVersion !== currentVersion || existingMetadata.siteBuildDate !== currentBuildDate;

        // Mettre à jour les métadonnées avec la nouvelle version et la date de connexion
        const updatedMetadata = {
          ...existingMetadata,
          siteVersion: currentVersion,
          siteBuildDate: currentBuildDate,
          lastConnectionDate: currentDateTime,
          ...(versionChanged && { lastVersionUpdate: currentDateTime })
        };

        // Envoyer la mise à jour au backend
        await this.$axios.put(`${this.$strapi.options.url}api/users/${this.user.id}`, {
          metadata: updatedMetadata
        }, {
          headers: {
            Authorization: `Bearer ${this.$strapi.getToken()}`
          }
        });

        console.log(`Métadonnées utilisateur mises à jour - Version: ${currentVersion} (${currentBuildDate}) - Dernière connexion: ${currentDateTime}`);
        
        // Mettre à jour le store local
        this.$store.commit('SET_USER', {
          ...this.user,
          metadata: updatedMetadata
        });

      } catch (error) {
        console.error('Erreur lors de la mise à jour des métadonnées utilisateur:', error);
      }
    },
  },
  watch: {
    '$route.path': function(newPath) {
      const keywords = ['profil', 'user', 'login', 'register', 'forgot-password'];
      if (keywords.some(keyword => newPath.includes(keyword))) {
        this.backgroundColor = 'white'; // Style de fond pour les routes correspondant aux mots-clés
      } else {
        this.backgroundColor = '#292828'; // Style de fond par défaut
      }
    },
    searchModel(val) {
            this.$store.dispatch('setSearch', val);
        },
  }

};
</script>

<style lang="scss">

  @import 'assets/css/global.scss';
  @import 'assets/css/animation.scss';
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');

  // @font-face {
  //   font-family: 'Neue Machina';
  //   src: url('@/fonts/NeueMachina-Light.otf') format('otf')
  // }
  @font-face {
      font-family: 'NeueMachina-Light';
      src: url('https://static1.squarespace.com/static/60e5873ca8ce0e29b11d365e/t/60e588f06c0d015ae5599065/1625655536892/NeueMachina-Light.otf')
  }

  :root {
      --font-neue-machina: 'NeueMachina-Light', sans-serif;
  }

@media (min-width: 1024px) {
  .base-accordion .v-expansion-panel {
      box-shadow: inset -2px 1px 1px #ffe200;
      top:-25px;
  }

  .accordion-sheet.v-sheet.theme--light {
      box-shadow: inset -2px 2px 1px #ffe200!important;
  }

  #main-router{
    background-color: #292828;
  }
}

</style>

<style>


.principal-logo{
  margin-top: calc(env(safe-area-inset-top, 0px) + 12px); /* Combine l'encoche et une marge supplémentaire */

}
  .fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
  /* Cacher la barre de défilement  */
  html {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

</style>